import React, {FC} from 'react';
import Stack from '@mui/material/Stack';
import WarningIcon from '@mui/icons-material/Warning';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DialogPanel from '@/components/DialogPanel';
import {useTranslation} from 'react-i18next';

//TYPES
export type NoParcelsForProjectDialogProps = {
  onProjectDeselect: () => void
};

const WithoutParcelsDialog: FC<NoParcelsForProjectDialogProps> = ({onProjectDeselect}) => {

  const {t} = useTranslation();

  return <DialogPanel isOpen={true} label={t('withoutParcels.title').toUpperCase()} onClose={onProjectDeselect}>
    <Stack direction="column" sx={{alignItems: 'center', gap: 3, m: 2}}>
      <Stack direction="row" sx={{gap: 1}}>
        <WarningIcon color="warning"/>
        <Typography>{t('withoutParcels.description')}</Typography>  
      </Stack>
      <Button variant="contained" sx={{width: '200px'}} onClick={onProjectDeselect}>{t('withoutParcels.accept')}</Button>
    </Stack>
  </DialogPanel>;
};
export default WithoutParcelsDialog;